import { render } from "./TheWinModal.vue?vue&type=template&id=3f2348f3"
import script from "./TheWinModal.vue?vue&type=script&lang=js"
export * from "./TheWinModal.vue?vue&type=script&lang=js"
script.render = render

export default script